<template>
    <thead class="border-b border-divider">
        <slot />
    </thead>
</template>
